import {
  GalaxyFilterDefinitionInterface,
  GalaxyFilterInterface,
  GalaxyFilterOperator,
} from '@vendasta/galaxy/filter/chips';
import { inject, Injectable } from '@angular/core';
import { combineLatest, firstValueFrom, Observable, of } from 'rxjs';
import { CrmFieldService } from '../crm-services';
import { CrmInjectionToken } from '../../tokens-and-interfaces';

@Injectable()
export class ActivityCustomizationService {
  private readonly config = inject(CrmInjectionToken);
  private readonly crmFieldService = inject(CrmFieldService);

  buildInitialFilter(filterDefinitions: GalaxyFilterDefinitionInterface[], identifier: string, filterId: string) {
    const fieldId = this.crmFieldService.getFieldId(identifier);
    const defn = filterDefinitions.find((f) => f.fieldId === fieldId);
    if (defn) {
      defn.preset = true;
    }
    const filter = {
      fieldId: fieldId,
      filterId: filterId,
      operator: GalaxyFilterOperator.FILTER_OPERATOR_IS,
      values: [],
      definition: defn,
    };
    return filter;
  }

  getInitialFilters(
    filterDefinitions$: Observable<GalaxyFilterDefinitionInterface[]>,
  ): Promise<GalaxyFilterInterface[]> {
    return firstValueFrom(combineLatest([filterDefinitions$, this.config.activity?.initialFilters$ || of([])])).then(
      ([filterDefinitions, initialFilters]) => {
        return initialFilters.map((filter) => {
          return this.buildInitialFilter(filterDefinitions, filter.fieldId, filter.filterId);
        });
      },
    );
  }
}
